import { ApiInstance } from 'api/api-instance';
import { BaseResponse } from 'api/api.types';
import { GET_MY_VEHICLES_URL } from 'api/vehicles/vehicles.constant';
import { GetVehiclesRequest, MyVehiclesResponse } from './vehicles.type';
import { getSearchParams, transformResponse } from './vehicles.adapter';

export class VehiclesApi extends ApiInstance {
  public async getMyVehicles(request: GetVehiclesRequest): Promise<BaseResponse<MyVehiclesResponse>> {
    const response: BaseResponse<any> = await this.execute<MyVehiclesResponse>(
      this.http.post(GET_MY_VEHICLES_URL, getSearchParams(request)),
    );

    if (!response.hasError()) {
      return new BaseResponse<MyVehiclesResponse>({
        ...transformResponse(response.data),
      });
    }

    return response;
  }
}
